<template>
  <div ref="element" class="ChoiceImage" :class="{ 'enable': used != null }" @click="onClick()">
    <img 
      class="ChoiceImage__close" 
      :class="{ 'enable': used != null }" 
      :src="require('../img/assets/close.png')"/>
    <img :src="require('../img/emotions/' + img + '.png')" v-if="used"/>
  </div>
</template>
<script>
export default {
  name: 'ChoiceImage',
  data: () => ({
    img: null,
    id: 0,
    used: null,
  }),
  watch: {
    drag_end(nw, od) {
      if(nw.choice == this.id){
        this.$store.commit('app/SET_AMBIANCE', 'selection')
        TweenMax.from(this.$refs.element, .7 ,{ scale: .5, ease: Cubic.easeOut })
        this.used = nw.id
      }
    },
    drag_back(nw, od) {
      if(nw.choice == this.id)
        this.used = null
    },
    used(nw, od) {
      this.img = this.$parent.$parent.emotions[this.used]
    },
  },
  computed: {
    drag_end() { return this.$store.getters['app/drag_end'] },
    drag_back() { return this.$store.getters['app/drag_back'] }
  },
  methods: {
    onClick() {
      this.$store.commit('app/SET_AMBIANCE', 'delete')
      this.$store.commit('app/DRAG_BACK', { choice: this.id, id: this.used })
    },
  }, 
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.ChoiceImage
  position relative
  width 124px
  height 121px
  display flex
  justify-content center
  align-items center
  pointer-events none
  cursor pointer

  +max-screen-height(tablet-portrait)
    width 110px

  &.enable 
    pointer-events initial

  &__close 
    position absolute
    opacity 0
    width 20px
    top 18px
    right 36px

    +max-screen-height(tablet-portrait)
      right 24px

    &.enable 
      opacity 1

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/ChoiceImage.vue